var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 4.75L7.55582 7.85093C9.57344 8.99413 10.4259 8.99413 12.4435 7.85093L17.9163 4.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09549 10.6682C2.14724 13.0951 2.17312 14.3085 3.0686 15.2074C3.96407 16.1063 5.21035 16.1376 7.70292 16.2002C9.23912 16.2388 10.7602 16.2388 12.2965 16.2002C14.789 16.1376 16.0353 16.1063 16.9308 15.2074C17.8263 14.3085 17.8521 13.0951 17.9038 10.6682C17.9205 9.88782 17.9205 9.11214 17.9038 8.3318C17.8521 5.90491 17.8263 4.69147 16.9308 3.79259C16.0353 2.8937 14.789 2.86239 12.2965 2.79977C10.7602 2.76116 9.23912 2.76116 7.70291 2.79976C5.21035 2.86238 3.96407 2.89369 3.06859 3.79258C2.17312 4.69146 2.14724 5.9049 2.09548 8.3318C2.07884 9.11214 2.07885 9.88782 2.09549 10.6682Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7a0884f5dfd08b5f97d7c5765c3ad5a8.svg";
export { ForwardRef as ReactComponent };